import React, { useEffect, useState } from "react";
import { CiFileOn } from "react-icons/ci";
import LoadingSharedFile from "./LoadingSharedFile";
import ErrorPage from "../../Components/ErrorPage";
import CryptoJS from "crypto-js";
import { useLanguage } from "../../Translations/LenguageContext";
import { MdOutlineContentCopy, MdShare } from "react-icons/md";
import InfoModal from "./InfoModal";

const SharedFile = () => {
    const { t } = useLanguage();
    const [userId, setUserId] = useState("");
    const [fileIds, setFileIds] = useState([]);
    const [selectedBtn, setSelectedBtn] = useState("allFiles");
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [files, setFiles] = useState([]);
    const [filteredFiles, setFilteredFiles] = useState([]);
    const [fileCount, setFileCount] = useState(0);
    const [senderName, setSenderName] = useState("");
    const [secretKey, setSecretKey] = useState(null)
    const [searchQuery, setSearchQuery] = useState("");
    const [copied, setCopied] = useState(false);
    const [showInfoModal, setShowInfoModal] = useState(false)

    const GetKey = async () => {
        try {
            const response = await fetch('https://backend.erioon.com/return_crptid', {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
            });

            if (response.ok) {
                const result = await response.json();
                setSecretKey(result.key)
            } else {
                console.error("Error fetching key:", response.statusText);
            }
        } catch (error) {
            console.error("Encryption key fetch failed", error);
        }
    }

    useEffect(() => {
        GetKey()
    }, []);

    useEffect(() => {
        const currentUrl = window.location.href;
        const urlPath = currentUrl.split("/sf/")[1];

        if (urlPath && secretKey) {
            const decryptedData = decryptData(urlPath);
            const [user, fileIdsString] = decryptedData.split("/");
            const fileArray = fileIdsString ? fileIdsString.split("_") : [];

            setUserId(user);
            setFileIds(fileArray);
            getSharedFiles(user, fileArray);
        }
    }, [secretKey]);

    const decryptData = (encryptedData) => {
        if (!secretKey) {
            console.error("Secret key is missing");
        }

        const bytes = CryptoJS.AES.decrypt(encryptedData, secretKey);
        const decryptedData = bytes.toString(CryptoJS.enc.Utf8);
        return decryptedData;
    };


    const getSharedFiles = async (user, fileArray) => {
        setLoading(true);
        try {
            const response = await fetch("https://backend.erioon.com/get_specific_files", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({ user_id: user, file_ids: fileArray }),
            });
            if (response.ok) {
                const result = await response.json();
                const files = result.files || [];
                const user_name = result.user_name || "";
                const user_surname = result.user_surname || "";
                const complete_name = `${user_name} ${user_surname}`
                setSenderName(complete_name);
                document.title = `Shared space | ${complete_name}`;

                if (Array.isArray(files)) {
                    setFiles(files);
                    setFilteredFiles(files);
                    setFileCount(files.length);
                } else {
                    throw new Error("Invalid response format");
                }
            } else {
                const errorData = await response.json();
                setError(errorData.message || "Failed to load files.");
            }
            setLoading(false);
        } catch (err) {
            setLoading(false);
            console.error("Error fetching files:", err);
            setError("Failed to connect to the server. Please try again later.");
        }
    };

    const handleSearch = (event) => {
        const query = event.target.value.toLowerCase();
        setSearchQuery(query);

        if (query.trim() === "") {
            setFilteredFiles(files);
            return;
        }

        const filtered = files.filter((file) => {
            return (
                file._id.toLowerCase().includes(query) ||
                file.filename.toLowerCase().includes(query) ||
                file.status.toLowerCase().includes(query) ||
                file.timestamp.toLowerCase().includes(query) ||
                file.file_url.toLowerCase().includes(query)
            );
        });

        setFilteredFiles(filtered);
    };

    const handleCopyToClipboard = () => {
        const currentUrl = window.location.href;
        navigator.clipboard.writeText(currentUrl)
            .then(() => {
                setCopied(true);
                setTimeout(() => setCopied(false), 2000);
            })
            .catch((error) => {
                console.error('Error copying to clipboard: ', error);
            });
    };
    
    const handleCloseInfoModal = () => {
        setShowInfoModal(false)
    }

    const isImageUrl = (url) => {
        const imageExtensions = /\.(jpg|jpeg|png|gif|bmp|tiff)$/i;
        return imageExtensions.test(url);
    };

    if (loading) {
        return <LoadingSharedFile />;
    }

    if (error) {
        return <ErrorPage />;
    }

    return (
        <div className="shared_file_main_cont fade-in">
            {fileCount != 0 && (
                <div className="user_share_cont">
                    <div className="user_share">{senderName} {t.shared_space.sender_text}</div>
                    <div className="user_share" onClick={() => {setShowInfoModal(true)}}>
                        <i className="fa-solid fa-question"></i>
                    </div>
                </div>
            )}

            <div className="header_actions">
                <button className={`share_file_btns ${selectedBtn === "allFiles" ? "active_share_btn" : ""}`} onClick={() => setSelectedBtn("allFiles")}>
                    {t.shared_space.all_files}
                </button>
                {fileCount != 0 && (
                    <>
                        <button className="share_file_btns allFiles active_share_btn" onClick={handleCopyToClipboard}>
                            {copied ? (
                                <>
                                    <i className="fa-solid fa-check"></i> {t.shared_space.item_copied}
                                </>
                            ) : (
                                <>
                                    <MdShare /> {t.shared_space.share}
                                </>

                            )}
                        </button>
                    </>
                )}
            </div>
            <div className="shared_file_main_inner">
                {fileCount === 0 ? (
                    <div className="no_available_files_cont">
                        <p>{senderName} {t.shared_space.no_file_mex}</p>
                        <img className="icon_img" src="/IMG/files_search.png" />
                    </div>
                ) : (
                    <>
                        <div className="file_details">
                            <p className="file_amount">
                                {fileCount} {fileCount === 1 ? t.shared_space.item : t.shared_space.items}
                            </p>
                            <div className="filter_input_cont">
                                <i className="fa-solid fa-magnifying-glass"></i>
                                <input
                                    className="filter_input"
                                    placeholder={t.search}
                                    value={searchQuery}
                                    onChange={handleSearch}
                                />
                            </div>
                        </div>
                        <div className="files_list">
                            {filteredFiles.length === 0 ? (
                                <div className="no_org_cont">
                                    <p>{t.shared_space.no_items_found}</p>
                                </div>
                            ) : (
                                <>
                                    {filteredFiles.map((file) => {
                                        const sizeInKB = file.size_kb || 0;
                                        const formattedSize = sizeInKB >= 1024 ? `${(sizeInKB / 1024).toFixed(2)} MB` : `${sizeInKB.toFixed(2)} KB`;

                                        return (
                                            <div className="file_item" key={file._id}>
                                                <div className="file_preview">
                                                    {isImageUrl(file.file_url) ? (
                                                        <img src={file.file_url} alt="File preview" />
                                                    ) : (
                                                        <i>
                                                            <CiFileOn />
                                                        </i>
                                                    )}
                                                </div>
                                                <div className="file_name">
                                                    <p>{file.filename}</p>
                                                </div>
                                                <div className="size_file">
                                                    <p>{formattedSize}</p>
                                                    <a href={file.file_url} download>
                                                        <i className="fa-solid fa-download"></i>
                                                    </a>
                                                </div>
                                            </div>
                                        );
                                    })}
                                </>
                            )}
                        </div>
                    </>
                )}
            </div>
            <InfoModal
                show={showInfoModal}
                handleClose={handleCloseInfoModal}
            />
        </div>
    );


};

export default SharedFile;
